module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/Attendance-Leaves/time-roll-generation/time-roll-gen-grid/time-roll-gen-grid.component.css
// module id = ./src/app/hrms/Attendance-Leaves/time-roll-generation/time-roll-gen-grid/time-roll-gen-grid.component.css
// module chunks = main